import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';

import CustomersApi from '../../../services/api/customers';
import MachineApi from '../../../services/api/machines';
import ConfirmationDialog from '../../../views/ConfirmationDialog/ConfirmationDialog';

import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import InputGroup from 'react-bootstrap/InputGroup';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import classes from './ApiSettings.module.css';
import machines from '../../../services/api/machines';

class ApiSettings extends Component {
	state = {
		apiSettings: {
			services: []
		},		
		changed: false,
		confirmation: {
			isOpen: false,
			type: null,
			targetId: null
		}
	};

	services = [
		{
			id: 'apiLayoutHandling',
			name: this.props.t(
				'partnerManagement.apiSettings.services.layoutHandling'
			)
		},
		{
			id: 'apiRemoteControl',
			name: this.props.t('partnerManagement.apiSettings.services.remoteControl')
		},
		{
			id: 'apiRunnerControl',
			name: this.props.t(
				'partnerManagement.apiSettings.services.remoteRunnerControl'
			)
		},
		{
			id: 'apiInfoTextControl',
			name: this.props.t(
				'partnerManagement.apiSettings.services.remoteInfoTextControl'
			)
		},
		{
			id: 'apiLogAccess',
			name: this.props.t('partnerManagement.apiSettings.services.logAccess')
		},
		{
			id: 'apiRemotePriceChange',
			name: this.props.t(
				'partnerManagement.apiSettings.services.remotePriceChange'
			)
		}
	];

	componentDidMount() {
		//this.loadServices();
		this.loadApiSettings();
		//this.loadHardware();
	}

	async loadApiSettings() {
		try {
			const result = await CustomersApi.getApiSettings(
				this.props.customer.cmID
			);
			this.setState({ apiSettings: result.data });
		} catch (error) {
			console.error('Error loading API settings:', error);
			// Initialize with default settings if API call fails
			this.setState({
				apiSettings: {
					apiAccessEnabled: false,
					apiKey: ''
				}
			});
		}
	}

	async loadServices() {
		/*
		try {
			const result = await CustomersApi.getApiServices(
				this.props.customer.cmID
			);
			this.setState({ services: result.data || [] });
		} catch (error) {
			console.error('Error loading services:', error);
			// Initialize with default services
			this.setState({
				services: this.services.map((service) => ({
					...service,
					enabled: false
				}))
			});
		}*/
	}

	async loadHardware() {
		try {			
			const result = await MachineApi.getVmBycmID(this.props.customer.cmID);
			if (!result.data.error) {
				const hardwareList = result.data.response
					.map((vm) => ({
						id: vm.vmID,
						hardwareId: vm.id,
						machineName: vm.customName || vm.name || 'Unknown',
						apiKey:
							vm.apiKey ||
							this.props.t('partnerManagement.apiSettings.notGenerated')
					}))
					.filter(
						(hw) =>
							hw.hardwareId &&
							hw.hardwareId.toUpperCase().indexOf('V') === -1
					); // Filter out entries without hardwareId or with hardwareId containing 'V'
				this.setState({ hardware: hardwareList });
			}
		} catch (error) {
			console.error('Error loading hardware:', error);
			this.setState({ hardware: [] });
		}
	}

	handleFormSubmit(e) {
		e.preventDefault();
	}

	inputUpdate(e) {
		const apiSettings = { ...this.state.apiSettings };
		if (e.target.type !== 'checkbox') {
			apiSettings.services[e.target.id] = e.target.value;
		} else {
			apiSettings.services[e.target.id] = e.target.checked;
		}
		this.setState({ apiSettings, changed: true });
	}

	isChecked(serviceId) {
		return this.state.apiSettings?.services?.[serviceId] ?? false;
	}

	serviceUpdate(serviceId, enabled) {
		const services = {
			...this.state.apiSettings.services,
			[serviceId]: enabled
		};

		this.setState({
			apiSettings: { ...this.state.apiSettings, services },
			changed: true
		});
	}

	showConfirmation(type, targetId = null) {
		this.setState({
			confirmation: {
				isOpen: true,
				type,
				targetId
			}
		});
	}

	hideConfirmation = () => {
		this.setState({
			confirmation: {
				isOpen: false,
				type: null,
				targetId: null
			}
		});
	};

	handleConfirmation = () => {
		const { type, targetId } = this.state.confirmation;
		switch (type) {
			case 'regenerateApi':
				this.doRegenerateApiKey();
				break;
			case 'regenerateHardware':
				this.doRegenerateHardwareKey(targetId);
				break;
			case 'clearApi':
				this.doClearApiKey();
				break;
			default:
				break;
		}
		this.hideConfirmation();
	};

	regenerateApiKey() {
		this.showConfirmation('regenerateApi');
	}

	getRandomApiKey() {
		return (
			Math.random().toString(36).substring(2, 15) +
			Math.random().toString(36).substring(2, 15)
		);
	}

	doRegenerateApiKey() {
		const newAPIKey = this.getRandomApiKey();
		const apiSettings = {
			...this.state.apiSettings,
			services: {
				...this.state.apiSettings.services,
				apiKey: newAPIKey
			}
		};

		this.setState({ apiSettings, changed: true });
	}

	async clearHardwareKey(hardwareId) {
		try {			
			const machines = this.state.apiSettings.machines.map((hw) =>
				hw.id === hardwareId
					? {
							...hw,
							apiKey: null
						}
					: hw
			);
			this.setState({ apiSettings: { ...this.state.apiSettings, machines }, changed: true });
		} catch (error) {
			console.error('Error clearing hardware key:', error);
		}
	}

	regenerateHardwareKey(hardwareId) {
		this.showConfirmation('regenerateHardware', hardwareId);
	}

	async doRegenerateHardwareKey(hardwareId) {
		try {
			const newApiKey = this.getRandomApiKey();	
			const machines = this.state.apiSettings.machines.map((hw) =>
				hw.id === hardwareId ? { ...hw, apiKey:  newApiKey} : hw
			);
			this.setState({ apiSettings: { ...this.state.apiSettings, machines }, changed: true });
		} catch (error) {
			console.error('Error regenerating hardware key:', error);
		}
	}

	clearApiKey() {
		this.showConfirmation('clearApi');
	}

	doClearApiKey() {
		const apiSettings = { ...this.state.apiSettings, services: { ...this.state.apiSettings.services, apiKey: '' } };
		this.setState({ apiSettings, changed: true });
	}

	async saveChanges() {
		try {					
			if (this.props.customer.cmID) {
				await CustomersApi.setApiSettings(
					this.props.customer.cmID,
					this.state.apiSettings
				);			
				this.setState({ changed: false });
			}
		} catch (error) {
			console.error('Error saving API settings:', error);
		}
	}

	getConfirmationTitle() {
		const { type } = this.state.confirmation;
		switch (type) {
			case 'regenerateApi':
				return this.props.t(
					'partnerManagement.apiSettings.confirmations.regenerateApiKeyTitle'
				);
			case 'regenerateHardware':
				return this.props.t(
					'partnerManagement.apiSettings.confirmations.regenerateHardwareKeyTitle'
				);
			case 'clearApi':
				return this.props.t(
					'partnerManagement.apiSettings.confirmations.clearApiKeyTitle'
				);
			default:
				return '';
		}
	}

	getConfirmationMessage() {
		const { type } = this.state.confirmation;
		switch (type) {
			case 'regenerateApi':
				return this.props.t(
					'partnerManagement.apiSettings.confirmations.regenerateApiKeyMessage'
				);
			case 'regenerateHardware':
				return this.props.t(
					'partnerManagement.apiSettings.confirmations.regenerateHardwareKeyMessage'
				);
			case 'clearApi':
				return this.props.t(
					'partnerManagement.apiSettings.confirmations.clearApiKeyMessage'
				);
			default:
				return '';
		}
	}

	renderKeyButton = (cell, row) => {
		const isApiEnabled = this.state.apiSettings?.services?.apiServiceEnabled ?? false;
		return (
			<InputGroup size="sm">
				<Form.Control
					type="text"
					value={
						row.apiKey ||
						this.props.t('partnerManagement.apiSettings.notGenerated')
					}
					readOnly
					style={{ fontSize: '12px' }}
					disabled={!isApiEnabled}
				/>
				<Button
					variant="outline-secondary"
					size="sm"
					onClick={() => this.clearHardwareKey(row.id)}
					title={this.props.t('partnerManagement.apiSettings.regenerate')}
					disabled={!isApiEnabled}
				>
					<i className="fa fa-close" aria-hidden="true"></i>
				</Button>
				<Button
					variant="outline-secondary"
					size="sm"
					onClick={() => this.regenerateHardwareKey(row.id)}
					title={this.props.t('partnerManagement.apiSettings.resetApiKey')}
					disabled={!isApiEnabled}
				>
					<i className="fa fa-refresh" aria-hidden="true"></i>
				</Button>
			</InputGroup>
		);
	};

	render() {
		const hardwareTableOptions = {
			defaultSortName: 'hardwareId',
			defaultSortOrder: 'asc'
		};

		const isApiEnabled =
			this.state.apiSettings?.services?.apiServiceEnabled ?? false;

		return (
			<Form id="apiSettingsForm" onSubmit={(e) => this.handleFormSubmit(e)}>
				{/* API Access Enable/Disable */}
				<div className={classes.formSection}>
					<Form.Check
						id="apiServiceEnabled"
						type="checkbox"
						label={this.props.t(
							'partnerManagement.apiSettings.enableApiAccess'
						)}
						checked={isApiEnabled}
						onChange={(e) => this.inputUpdate(e)}
						disabled={this.props.disabled}
						style={{ display: 'inline', marginRight: '10px' }}
					/>
				</div>

				{/* Disabled Content Wrapper */}
				<div
					className={`${classes.disabledContent} ${!isApiEnabled ? classes.disabled : ''}`}
				>
					{/* Overlay */}
					{!isApiEnabled && <div className={classes.overlay}></div>}

					{/* API Key Section */}
					<div className={classes.formSection}>
						<Form.Label>
							{this.props.t('partnerManagement.apiSettings.apiKey')}
						</Form.Label>
						<InputGroup className={classes.keyInputGroup}>
							<Form.Control
								id="apiKey"
								type="text"
								value={
									this.state.apiSettings?.services?.apiKey ||
									this.props.t('partnerManagement.apiSettings.notGenerated')
								}
								readOnly
								disabled={this.props.disabled || !isApiEnabled}
							/>
							<Button
								variant="outline-secondary"
								onClick={() => this.clearApiKey()}
								disabled={
									this.props.disabled ||
									!isApiEnabled ||
									!this.state.apiSettings?.services?.apiKey
								}
							>
								<i className="fa fa-close" aria-hidden="true"></i>
							</Button>
							<Button
								variant="outline-secondary"
								onClick={() => this.regenerateApiKey()}
								disabled={this.props.disabled || !isApiEnabled}
							>
								<i className="fa fa-refresh" aria-hidden="true"></i>
							</Button>
						</InputGroup>
					</div>

					<hr />

					{/* Services List */}
					<div className={classes.formSection}>
						<h6 className={classes.sectionHeader}>
							{this.props.t('partnerManagement.apiSettings.apiServices')}
						</h6>
						<Row>
							{this.services.map((service) => (
								<Col md={6} key={service.id}>
									<Form.Check
										type="checkbox"
										id={`service-${service.id}`}
										label={service.name}
										checked={this.isChecked(service.id)}
										onChange={(e) =>
											this.serviceUpdate(service.id, e.target.checked)
										}
										disabled={this.props.disabled || !isApiEnabled}
										className={classes.serviceCheckbox}
									/>
								</Col>
							))}
						</Row>
					</div>

					<hr />

					{/* Hardware List */}
					<div className={classes.formSection}>
						<h6 className={classes.sectionHeader}>
							{this.props.t('partnerManagement.apiSettings.hardwareApiKeys')}
						</h6>
						<div className={classes.apiTable}>
							<BootstrapTable
								data={this.state.apiSettings.machines || []}
								striped
								version="4"
								pagination={false}
								insertRow={false}
								options={hardwareTableOptions}
								condensed
								bordered={false}
								dataAlign={'center'}
								size="sm"
								className={'react-bs-table-gray-border'}
							>
								<TableHeaderColumn
									dataField="hardwareId"
									dataSort
									width="120"
									isKey
								>
									{this.props.t('partnerManagement.apiSettings.hardwareId')}
								</TableHeaderColumn>
								<TableHeaderColumn dataField="machineName" dataSort width="200">
									{this.props.t('partnerManagement.apiSettings.machineName')}
								</TableHeaderColumn>
								<TableHeaderColumn
									dataField="apiKey"
									dataFormat={this.renderKeyButton}
									width="300"									
								>
									{this.props.t('partnerManagement.apiSettings.apiKey')}
								</TableHeaderColumn>
							</BootstrapTable>
						</div>
					</div>
				</div>

				{/* Save Button */}
				<Button
					variant="success"
					type="submit"
					disabled={!this.state.changed || this.props.disabled}
					className={`DefaultButton ${classes.saveButton}`}
					onClick={() => this.saveChanges()}
				>
					<i className="fa fa-floppy-o" aria-hidden="true"></i>&nbsp;
					{this.props.t('partnerManagement.customerGeneral.save')}
				</Button>

				{/* Confirmation Dialog */}
				<ConfirmationDialog
					isOpen={this.state.confirmation.isOpen}
					onToggle={this.hideConfirmation}
					onCancel={this.hideConfirmation}
					onOk={this.handleConfirmation}
					title={this.getConfirmationTitle()}
					confirmationText={this.getConfirmationMessage()}
					okText={this.props.t(
						'partnerManagement.apiSettings.confirmations.confirmButton'
					)}
					cancelText={this.props.t(
						'partnerManagement.apiSettings.confirmations.cancelButton'
					)}
				/>
			</Form>
		);
	}
}

export default withTranslation()(ApiSettings);
